export default __webpack_public_path__ + "ea240d55e6e077c54a201c25dca90f60.png";